import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  listAccounts,
  openInviteNewUser,
  retrieveCredentials,
  viewUsers,
} from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import { closeUserSuccess, createInviteUser } from '../../actions/user';
import { openDialog, closeDialog } from '../../actions/dialog';
import AccountsPage from './AccountsPage';

export class AccountsPageContainer extends React.Component {
  static propTypes = {
    closeDialogAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    inviteNewUserAction: PropTypes.func.isRequired,
    listAccountsAction: PropTypes.func.isRequired,
    retrieveCredentialsAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    superadmin: PropTypes.object.isRequired,
    userInvite: PropTypes.object.isRequired,
    viewUsersAction: PropTypes.func.isRequired,
  };

  state = { selectedAccountId: undefined };

  componentWillMount = () => {
    const { listAccountsAction } = this.props;
    const token = storeWithExpiration.get('token');
    listAccountsAction(token);
  };

  componentWillUnmount = () => {
    const { dialog, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(dialog.id);
    }
  };

  toggleSelectAccount = accountId => {
    this.setState(prevState => {
      if (prevState.selectedAccountId === accountId) {
        return { selectedAccountId: undefined };
      }
      return { selectedAccountId: accountId };
    });
  };

  toggleDialog = (account, id) => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show && (dialog.id === 'addUserDialog' || 'sftpDialog' || 'addEmailsDialog')) {
      closeDialogAction(id);
    } else {
      openDialogAction(id, account.id);
    }
  };

  cancelDialog = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  performLinkToInviteUser = id => {
    const { inviteNewUserAction } = this.props;
    inviteNewUserAction(id);
  };

  render() {
    const {
      superadmin,
      userInvite,
      dialog,
      retrieveCredentialsAction,
      viewUsersAction,
    } = this.props;
    const { selectedAccountId } = this.state;

    return (
      <div className="modal-wrap">
        <div className="container-fluid">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-md-10">
                  <h1 className="header-title">Accounts</h1>
                </div>
                <div className="col-md-2">
                  <span>
                    <Link to="/superadmin/create" className="btn btn-primary">
                      <i className="fa fa-plus" />
                      Create New Account
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <AccountsPage
            accounts={superadmin.get('accounts')}
            dialog={dialog}
            userInvite={userInvite}
            cancelDialogFunction={this.cancelDialog}
            retrieveCredentialsAction={retrieveCredentialsAction}
            selectedAccountId={selectedAccountId}
            toggleDialogFunction={this.toggleDialog}
            toggleSelectAccount={this.toggleSelectAccount}
            viewUsersAction={viewUsersAction}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { superadmin, dialog, userInvite } = state;
  return { superadmin, dialog, userInvite };
}

export default connect(
  mapStateToProps,
  {
    closeDialogAction: closeDialog,
    closeUserSuccessAction: closeUserSuccess,
    createInviteUserAction: createInviteUser,
    inviteNewUserAction: openInviteNewUser,
    listAccountsAction: listAccounts,
    openDialogAction: openDialog,
    retrieveCredentialsAction: retrieveCredentials,
    viewUsersAction: viewUsers,
  }
)(AccountsPageContainer);
